import { calendarSelectors } from "../modules/definition/calendar";
import repairFiltersRecord from "./repairFiltersRecord";
import repairRecordTree from "./repairRecordTree";
import repairSyncRecord from "./repairSyncRecord";

/**
 * Fix TimelineRecord after it has been converted to immutable object
 * Used if you need access to specific objects (e.g. Calendar) in the immutable format
 * already
 * @param {TimelineRecord} record
 * @returns {TimelineRecord}
 */
const repairTimelineRecord = (timelineRecord, fileVersion) => {
  let result = timelineRecord;
  if (fileVersion < 6) {
    const calendar = calendarSelectors.getCalendar(timelineRecord);
    result = repairRecordTree(timelineRecord, "TimelineRecord", calendar);
  }
  result = repairSyncRecord(result);
  result = repairFiltersRecord(result);
  return result;
};

export default repairTimelineRecord;
